import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";

const SideForm = ({ onEnquire }) => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ name: "", phone: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    if (!formData.name.trim()) return setError("Name is required");
    if (!/^\d{10}$/.test(formData.phone))
      return setError("Enter valid 10 digit mobile number");

    try {
      setLoading(true);
      setError("");

      const googleData = new FormData();
      googleData.append("Name", formData.name);
      googleData.append("Phone", formData.phone);

      const crmData = {
        name: formData.name,
        phone: formData.phone,
        listId: "6995869159756f0281ae5b89",
        redirect: "",
      };

      const googleRes = await fetch(
        "https://script.google.com/macros/s/AKfycbx0KzmDh-ttKhYNIiRDaUnHHVeixcH0A-3nJDOT-n1QfjQl5M24YKPt8QdKfW3N_qM-/exec",
        {
          method: "POST",
          body: googleData,
        }
      );

      // Fire CRM in background — don't block user flow on CRM errors
      fetch(
        "https://enterprise.godial.cc/meta/api/externals/contact/add?access_token=nbcLc99ivtoh5FO8xqGEOZEW6ddcb4szdtvHdVNCeTh980VQNehbfScBK0MvbQTb",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(crmData),
        }
      ).catch((err) => console.warn("CRM sync failed:", err));

      if (!googleRes.ok) throw new Error("Submission failed");

      setFormData({ name: "", phone: "" });
      navigate("/thank-you");

    } catch (err) {
      console.error("Lead submit error:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {/* Header */}
      <div className="relative grid grid-cols-2 bg-black text-white mb-4">
        <button
          className="flex items-center justify-center gap-2 border-r py-2"
          onClick={onEnquire}
        >
          📅 <span className="text-sm">Schedule Visit</span>
        </button>

        <button
          className="flex items-center justify-center gap-2 py-2"
          onClick={onEnquire}
        >
          📞 <span className="text-sm">+91 93269 59938</span>
        </button>
      </div>

      <div className="space-y-4 px-6">
        <h3 className="text-center font-semibold text-lg">
          Pre Register here for Best Offers
        </h3>

        <input
          type="text"
          name="name"
          placeholder="Enter Your Name here..."
          value={formData.name}
          onChange={handleChange}
          className="w-full border rounded-md px-3 py-2 focus:ring-2 focus:ring-green-500 outline-none"
        />

        <input
          type="tel"
          name="phone"
          placeholder="Phone Number"
          value={formData.phone}
          onChange={handleChange}
          className="w-full border rounded-md px-3 py-2 focus:ring-2 focus:ring-green-500 outline-none"
        />

        {error && <p className="text-red-500 text-sm text-center">{error}</p>}

        <div className="flex items-start gap-2 text-xs text-gray-600">
          <input type="checkbox" className="mt-1" defaultChecked />
          <p>
            I consent to the processing of provided data according to{" "}
            <span
              className="text-[#090C6A] underline cursor-pointer"
              onClick={() => {
                navigate("/policy");
                window.scrollTo(0, 0);
              }}
            >
              Privacy Policy
            </span>{" "}
            | Terms & Conditions.
          </p>
        </div>

        <button
          className="w-full bg-[#090c6a] hover:bg-[#1218A6] text-white font-semibold py-3 rounded-xl transition disabled:opacity-60"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "Submitting..." : "Pre Register Now"}
        </button>

        {/* Feature Icons */}
        <div className="flex items-center justify-center text-center text-xs gap-6 pt-3">
          <div className="flex flex-col items-center">
            <img src="/Images/Instant Call Back.gif" alt="Siddha Sky" className="w-10 h-10" />
            <p>Instant Call Back</p>
          </div>
          <div className="flex flex-col items-center">
            <img src="/Images/Site Assist.gif" alt="Siddha Sky" className="w-14 h-14" />
            <p>Free Site Assistance</p>
          </div>
          <div className="flex flex-col items-center">
            <img src="/Images/Best Price.gif" alt="Siddha Sky" className="w-10 h-10" />
            <p>Best Price</p>
          </div>
        </div>

        <button
          className="w-full bg-[#090c6a] hover:bg-[#1218A6] text-white font-semibold py-2 rounded-xl mt-2"
          onClick={onEnquire}
        >
          Request Call Back
        </button>
      </div>

      {/* Floating WhatsApp Button */}
      <a
        href="https://api.whatsapp.com/send?phone=9326959938&text=I am interested in Siddha Sky, Juhu project and want more information about this project."
        className="floating-button"
        target="_blank"
        rel="noreferrer"
      >
        <div className="fixed bottom-6 right-3 bg-[#25d366] text-center rounded-full text-white p-2">
          <FaWhatsapp size={30} />
        </div>
      </a>
    </div>
  );
};

export default SideForm;